import React, {Component} from "react";
import {Button, ButtonGroup, ListGroup, ListGroupItem, Spinner} from "react-bootstrap";
import {SendPlay, SendStop, SendPause, SendChangeLang} from "../../PilotPttRzeszow/services/webstomp.service";
import {PilotActionsConstants} from "../constants/pilot-actions.constants";
import {Link} from "react-router-dom";
import {dynamicRequest, dynamicRequestWithAutorize} from "../../PilotPttRzeszow/services/pilot.service";

export class PilotListPage extends Component {

    buildMuteUnmuteRequest = (deviceId, paramValue) => {
        return `/api/dashboard/changeVolume?id=${deviceId}&mute=${paramValue}`
    }

    sendMessage = (action, networkDevices = [] , value) => {
        switch (action) {
            case PilotActionsConstants.play:
                networkDevices.forEach((item) => SendPlay(item.Label));
                break;
            case PilotActionsConstants.pause:
                networkDevices.forEach((item) => SendPause(item.Label));
                break;
            case PilotActionsConstants.stop:
                networkDevices.forEach((item) => SendStop(item.Label));
                break;
            case PilotActionsConstants.changeMedia:
                networkDevices.forEach((item) => SendChangeLang(item.Label, value))
                break;
            case PilotActionsConstants.mute:
                networkDevices.forEach((item) => dynamicRequestWithAutorize(this.buildMuteUnmuteRequest(item.Id, true)).then(r => console.log(r)))
                break;
            case PilotActionsConstants.unmute:
                networkDevices.forEach((item) => dynamicRequestWithAutorize(this.buildMuteUnmuteRequest(item.Id, false)).then(r => console.log(r)))
                break;
            default:
                break;
        }
    }

    render() {
        const { data } = this.props;

        return (
            <>
                <div className="row">
                    <Link to={"/pilot"} className="m-4 text-right btn-lg btn-secondary">
                        <i className="fas fa-arrow-circle-left" /> &nbsp; Powrót
                    </Link>
                </div>
                <ListGroup>
                    { data.devicesList ? (
                        data.devicesList?.map((item, idx) => (
                            <ListGroupItem key={idx}>
                                <div className="d-flex align-content-center justify-content-between">
                                    <h3 key={idx} className="m-0 align-self-center persent-30"><b>{ item.label }</b></h3>
                                    { !data.disableLanguageControl ? (
                                        <div className="lang-changes align-self-center justify-content-end">
                                            <ButtonGroup size={"lg"} className="">
                                                { data.languages?.map((lang, idx) =>
                                                    (
                                                        <Button key={idx} variant={"outline-primary"} onClick={() => {
                                                            this.sendMessage(PilotActionsConstants.changeMedia, item.networkDevices, lang.value)
                                                        }}>{lang.label}</Button>
                                                    )
                                                ) }
                                            </ButtonGroup>
                                        </div>

                                    ) : (<React.Fragment/>) }

                                    <div className="button-group">

                                        { data.actions.includes('play') ? (
                                            <button className="btn btn-pilot-first btn-pilot-first-bg m-1" onClick={() => {
                                                this.sendMessage(PilotActionsConstants.play, item.networkDevices)
                                            }}>
                                                <i className="fas fa-play"/>&nbsp;Play
                                            </button>
                                        ) : (<React.Fragment/>) }

                                        { data.actions.includes('pause') ? (
                                            <button className="btn btn-pilot-first btn-pilot-first-bg m-1" onClick={() => {
                                                this.sendMessage(PilotActionsConstants.pause, item.networkDevices)
                                            }}>
                                                <i className="fas fa-pause"/>&nbsp;Pause
                                            </button>
                                        ) : (<React.Fragment/>) }

                                        { data.actions.includes('stop') ? (
                                            <button className="btn btn-pilot-first btn-pilot-first-bg m-1" onClick={() => {
                                                this.sendMessage(PilotActionsConstants.stop, item.networkDevices)
                                            }}>
                                                <i className="fas fa-stop"/>&nbsp;Stop
                                            </button>
                                        ) : (<React.Fragment/>) }

                                    </div>
                                    <div className="button-group">
                                        { data.actions.includes('mute') ? (
                                            <button className="btn btn-pilot-first btn-pilot-first-bg m-1" onClick={() => {
                                                this.sendMessage(PilotActionsConstants.mute, item.networkDevices)
                                            }}>
                                                <i className="fas fa-volume-mute"/>
                                            </button>
                                        ) : (<React.Fragment/>) }

                                        { data.actions.includes('unmute') ? (
                                            <button className="btn btn-pilot-first btn-pilot-first-bg m-1" onClick={() => {
                                                this.sendMessage(PilotActionsConstants.unmute, item.networkDevices)
                                            }}>
                                                <i className="fas fa-volume-up"/>
                                            </button>
                                        ) : (<React.Fragment/>) }
                                    </div>
                                </div>
                            </ListGroupItem>
                        ))
                    ) : (<Spinner animation={"border"}/>)}
                </ListGroup>
            </>
        );
    }
}
